import { Component, ChangeDetectionStrategy } from '@angular/core';
import packageJson from '../../../../package.json';
import { AboutPanelComponent, ButtonV3Component } from '@gea/digital-ui-lib';

@Component({
  selector: 'gea-hrt-version',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonV3Component],
  template: `
    <div>
      <header class="version-header">
        <h2>Versions</h2>
        <geaui-button-v3 type="tertiary" preIcon="close" aria-label="Close version panel" size="small" (click)="close()" />
      </header>
      <table class="version-table">
        <thead>
          <tr>
            <th>Package</th>
            <th>Version</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>App</td>
            <td>{{ appVersion }}</td>
          </tr>
          <tr>
            <td>@gea/digital-ui-lib</td>
            <td>{{ uiLibVersion }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  `,
  styles: `
    :host {
      display: block;
      padding: 1rem;
    }
    .version-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
    }
    .version-header h2 {
      margin: 0;
      font-size: 1.25rem;
    }
    .version-table {
      width: 100%;
      border-collapse: collapse;
      margin: 1rem 0;
      font-size: 1rem;
      background: #fff;
    }
    .version-table th,
    .version-table td {
      border: 1px solid #e0e0e0;
      padding: 0.75rem 1rem;
      text-align: left;
    }
    .version-table th {
      background: #f5f5f5;
      font-weight: 600;
    }
  `,
})
export class BRCVersionComponent extends AboutPanelComponent {
  readonly appVersion: string = packageJson.version ?? '';
  readonly uiLibVersion: string = packageJson.dependencies?.['@gea/digital-ui-lib'] ?? '';
}
